var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { getConfigVar } from "../../utils/Configuration";
import { checkKey, concatClassNames } from "../../utils/Functions";
import { Tooltip } from "../layout/Tooltip";
import { BaseInput } from "./BaseInput";
var Fileselect = /** @class */ (function (_super) {
    __extends(Fileselect, _super);
    function Fileselect(props) {
        var _this = _super.call(this, props, {}, props.defaultValue || null) || this;
        _this.getEventType = function () { return "change"; };
        _this.getPropertyName = function () { return "files"; };
        _this.onDragEnter = function (e) {
            _this.internalInput.focus();
            e.preventDefault();
            if (!_this.props.multiple && e.dataTransfer.items.length > 1)
                return;
        };
        _this.onDragOver = function (e) {
            e.stopPropagation();
            e.preventDefault();
        };
        _this.onDrop = function (e) {
            var _a = _this.props, disabled = _a.disabled, multiple = _a.multiple, files = e.dataTransfer.files;
            e.preventDefault();
            if (disabled || (!multiple && files.length > 1))
                return;
            _this.dispatchValue(files);
        };
        _this.onChange = function (e) {
            var _a = _this.props, disabled = _a.disabled, onChange = _a.onChange, files = e.target.files;
            if (disabled)
                return;
            _this.setState({ value: files }, function () {
                if (onChange)
                    onChange(files, e);
            });
        };
        _this.clickInput = function () {
            if (_this.props.disabled)
                return;
            _this.input.click();
        };
        _this.decodeValue = function () {
            var value = _this.state.value;
            if (!value || !value.length)
                return getConfigVar("SELECT_FILE");
            return Array.from(value).map(function (v) { return v.name; }).join(", ");
        };
        _this.resetInput = function () {
            _this.dispatchValue(null, null, "value");
            _this.internalInput.focus();
        };
        _this.render = function () {
            var _a = _this.props, required = _a.required, disabled = _a.disabled, className = _a.className, style = _a.style, multiple = _a.multiple, accept = _a.accept, type = _a.type, value = _this.state.value;
            return React.createElement("div", { className: "dolfo-control" },
                _this.getLabel(),
                React.createElement("div", { className: "dolfo-input-container" },
                    React.createElement("input", { type: "text", onChange: function () { }, required: required, className: "dolfo-input-files-hidden", value: value && value.length > 0 ? "SET" : "" }),
                    React.createElement("input", { ref: function (r) { return _this.input = r; }, type: "file", multiple: multiple, onChange: _this.onChange, accept: accept, className: "dolfo-input-files-hidden" }),
                    type === "drop-area" ? React.createElement("div", { ref: function (r) { return _this.internalInput = r; }, className: concatClassNames([
                            "dolfo-files-drop",
                            disabled ? "disabled" : ""
                        ], className), onDragOver: _this.onDragOver, onDragEnter: _this.onDragEnter, onDrop: _this.onDrop, onKeyDown: function (e) { return checkKey(e, _this.clickInput); }, tabIndex: !disabled ? 0 : null, onClick: _this.clickInput, style: style }, _this.decodeValue()) : React.createElement(React.Fragment, null,
                        React.createElement("input", { ref: function (r) { return _this.internalInput = r; }, type: "text", value: _this.decodeValue(), onClick: _this.clickInput, readOnly: true, style: style, className: concatClassNames(["dolfo-files-input", "dolfo-input-text"], className), disabled: disabled, onDragOver: _this.onDragOver, onDragEnter: _this.onDragEnter, onDrop: _this.onDrop, onKeyDown: function (e) { return checkKey(e, _this.clickInput); } }),
                        !disabled && value && value.length > 0 && React.createElement(Tooltip, { label: getConfigVar("RESET"), position: "left" },
                            React.createElement(FontAwesomeIcon, { icon: faXmark, className: "dolfo-input-reset", onClick: _this.resetInput })))));
        };
        return _this;
    }
    return Fileselect;
}(BaseInput));
export { Fileselect };
